import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconGifSizeM from './FileIconGif_size_m';
import FileIconGifSizeS from './FileIconGif_size_s';

export const FileIconGif = createFileIcon({
  m: FileIconGifSizeM,
  s: FileIconGifSizeS,
  name: 'FileIconGif',
});
